
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Location } from '@angular/common';
import { decrypt } from './utilities/utilityFunctions';
import { SharedService } from './shared/sharedServices/shared.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    public myRoute: Router,
    private sharedServices: SharedService
  ) {}

  canActivate(): boolean {
    if ((localStorage.getItem('esp-profile-details'))) { 
    let d = JSON.parse(decrypt(localStorage.getItem('esp-profile-details')));      
     if(d.profileId){
      // if(d.profileId && d.getSpRole.length == 0){
      return true;
    }
    } else {
      localStorage.clear();
      this.myRoute.navigate(['auth/login'])
      return false;
    }
  }

}
